import { IAdminSearchInquiriesProps } from '@interfaces/adminInquiries';

export const buildAdminInquiryListPayload = ({
  page,
  sort,
  search,
  pageSize,
  isPending,
}: IAdminSearchInquiriesProps) => ({
  pagedResultsRequest: {
    search: search || '',
    pagination: {
      page: page || 1,
      pageSize: pageSize || Number(process.env.REACT_APP_PAGE_SIZE_FOR_ADMIN_INQUIRIES_TABLE) || 5,
    },
    sort: sort || {
      active: 'inquiryStatusId',
      direction: 'asc',
    },
  },
  isPending,
});
